<template>
  <div class="py-4 container-fluid">
    <h4 class="text-white">ACTUALIZAR MENSAJE Y PANTALLA</h4>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Seleccionar tipo</label>
                                    <select  v-model="tipocambiar" id="tipocambiar" name="tipocambiar" class="form-select">
                                      <option value="" disabled>Seleccionar</option>
                                      <option value="V">ID DE VIDEO</option>
                                      <option value="T">MENSAJE DE PANTALLA</option>
                                    </select>
                                  </div>
              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Numero</label>
                <div class="form-group">
                  <input class="form-control" v-model="idvideotexto" placeholder="colocar id del video o texto" type="text"/>
                </div>
              </div>
              <div class="col-md-3 mt-4">
                <div class="form-group">
                  <div class="input-group input-group-merge">
                    <a
                      @click="actualizarpantallamensajevideo()"
                      type="button"
                      class="btn btn-info"
                    >
                      Actualizar
                      <i class="ni ni-world-2"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <br>
            <div class="row align-items-center py-4 mb-4">
                        <marquee><h1 class="d-inline-block mb-0">{{datosconfiguracion}}</h1></marquee>
                    </div>
                     <iframe
  :src="videoyoutube"
  frameborder="0"
  allow="autoplay; encrypted-media"
  allowfullscreen
  width="100%"
  height="800"
></iframe>
          </div>
      
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "profile",
  data() {
    return {
     tipocambiar:"",
     idvideotexto:"",
     datosconfiguracion:"",
    };
  },
  components: {},

  created: function () {
    this.verconfiguracion();
  },
  methods: {
     verconfiguracion(){
          axios.get("listarconfiguracion")
            .then((respuesta) => {
                 this.datosconfiguracion = respuesta.data[0].nombre;
                 this.videoyoutube=`https://www.youtube.com/embed/${respuesta.data[1].nombre}?autoplay=1&mute=1&loop=1&playlist=${respuesta.data[1].nombre}&controls=0&showinfo=0&modestbranding=1`
            }).catch((error) => {
             console.log(error);
            });
        },
         actualizarpantallamensajevideo() {
      const datosenv = {
        tipocambiar: this.tipocambiar,
        idvideotexto: this.idvideotexto,
      };
      axios
        .post("actualizarmensajevideo", datosenv)
        .then((respuesta) => {
          this.$swal.fire(
            "Exitoso",
            respuesta.data.mensaje,
            "success"
          );
          this.verconfiguracion();
          this.tipocambiar = "";
this.idvideotexto = "";
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.$swal.fire(
              "Ups!!",
              "Token Invalido Cierre Session e Ingrese de Nuevo",
              "error"
            );
          }
        });
    },
  },
};
</script>
<style scoped>
.coloriconos {
  color: white;
}
</style>
